<template>
  <div :id="id" :class="className" :style="{height:height,width:width}"/>
</template>

<script>
import * as echarts from 'echarts'
import resize from '@/utils/mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    goodsPieProduct: {
      type: null,
      default: ''
    }
  },
  data() {
    return {
      chart: null,
      options: {
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}单 , {d}%'
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          top: 48,
          itemGap: 50,
          itemWidth: 14,
          itemHeight: 14,
          icon: 'rect',
          data: []
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              },
              normal: {
                color: function(params) {
                  // 自定义颜色
                  const colorList = ['#FF7800', '#2298F0', '#FCA123', '#8989FF', '#40C52B', '#FF633F', '#64D3FF', '#BE97D8', '#5856D6', '#ECF0F3', '#E8684A', '#FF9D86', '#FEE8A5', '#B6E3F5', '#9270CA', '#8989FF', '#C03C3C', '#FFD8B8', '#007B7A']
                  return colorList[params.dataIndex]
                }
              }
            },
            label: {
              normal: {
                show: true,
                formatter: '{b}（{d}%）：{c}单'
              },
              emphasis: {
                show: true
              }
            }
          }
        ]
      }
    }
  },
  watch: {
    goodsPieProduct(value) {
      this.goodsPieProduct = value
      this.initChart()
    }
  },
  mounted() {
    this.chart = echarts.init(document.getElementById(this.id))
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      const vm = this
      // console.log(vm.goodsPieProduct)
      if (vm.goodsPieProduct == null || vm.goodsPieProduct === '') {
        vm.chart.showLoading()
      } else {
        vm.chart.hideLoading()
        const { list } = vm.goodsPieProduct
        const options = vm.options
        const serves = {
          0: '零元下单',
          1: '病人部分自理',
          2: '病人不能自理',
          3: '一级护理',
          4: '病人完全自理',
          5: '三级护理',
          6: '二级护理'
        }
        // 时间
        const goodsOrder = Object.keys(list).map(i => {
          return {
            name: serves[list[i].service_id],
            value: list[i].num,
            ...list[i]
          }
        })
        options.legend.data = goodsOrder.name
        options.series[0].data = goodsOrder
        vm.chart.setOption(options, true)
      }
    }
  }
}
</script>
